import React from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../../common/SafeIcon';

const { FiActivity, FiFileText } = FiIcons;

function AdminOverview({ articles, sources }) {
  const healthySources = sources.filter(
    (source) => source.active && !source.last_error
  ).length;

  const health = sources.length
    ? Math.round((healthySources / sources.length) * 100)
    : 0;

  return (
    <>
      <section className="admin-panel">
        <div className="admin-panel-head">
          <div>
            <span className="admin-overline">SYNDICATION</span>
            <h2>RSS source health</h2>
            <p>Live status from the connected Supabase project.</p>
          </div>
          <SafeIcon icon={FiActivity} />
        </div>

        {sources.slice(0, 6).map((source) => (
          <div className="import-row" key={source.id}>
            <span
              className={`import-dot ${source.last_error ? 'has-error' : ''}`}
            />
            <div>
              <b>{source.name}</b>
              <small>
                {source.updated} · {source.imported} articles imported
              </small>
            </div>
          </div>
        ))}

        {!sources.length && (
          <p className="admin-empty">No RSS sources are available.</p>
        )}
      </section>

      <section className="admin-columns">
        <div className="admin-panel">
          <div className="admin-panel-head">
            <div>
              <h2>Latest stories</h2>
              <p>Recently imported and published items</p>
            </div>
            <SafeIcon icon={FiFileText} />
          </div>

          {articles.slice(0, 6).map((article) => (
            <div className="import-row" key={article.id}>
              <span className="import-dot" />
              <div>
                <b>{article.title}</b>
                <small>{article.source} · {article.date}</small>
              </div>
            </div>
          ))}

          {!articles.length && (
            <p className="admin-empty">No articles have been imported yet.</p>
          )}
        </div>

        <div className="admin-panel admin-health">
          <span className="admin-overline">SYSTEM STATUS</span>
          <h2>Ingestion health</h2>
          <div className="health-number">{health}%</div>
          <p>
            Active sources currently reporting without a recorded error.
          </p>
          <div className="health-bar">
            <span style={{ width: `${health}%` }} />
          </div>
        </div>
      </section>
    </>
  );
}

export default AdminOverview;